export const CONNECTOR_ICONS: Record<string, string> = {
  email: "✉️",
  wrike: "✅",
  sharepoint: "🔵",
  asana: "📋",
  figma: "🎨",
  google_drive: "📁",
  canva: "🖼️",
  jira: "🧩",
  "microsoft-teams": "💬",
};
